(() => {
  if (customElements.get('j-clinical-comparison-2026')) return;
  customElements.define('j-clinical-comparison-2026', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelectorAll('[data-case]').forEach(button => {
        button.addEventListener('click', () => this.selectCase(button.dataset.case), options);
      });
      this.querySelectorAll('input[type="range"]').forEach(input => {
        const panel = input.closest('[data-panel]');
        const update = () => panel.style.setProperty('--clinical-position', `${input.value}%`);
        const move = event => {
          const rect = panel.getBoundingClientRect();
          if (!rect.width) return;
          input.value = Math.max(0, Math.min(100, (event.clientX - rect.left) / rect.width * 100));
          update();
        };
        input.addEventListener('input', update, options);
        input.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          event.preventDefault();
          input.focus({ preventScroll: true });
          input.setPointerCapture(event.pointerId);
          move(event);
        }, options);
        input.addEventListener('pointermove', event => {
          if (input.hasPointerCapture(event.pointerId)) move(event);
        }, options);
        input.addEventListener('pointerup', event => {
          if (input.hasPointerCapture(event.pointerId)) input.releasePointerCapture(event.pointerId);
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-panel]');
        if (panel && this.contains(panel)) this.selectCase(panel.dataset.panel);
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
    selectCase(id) {
      this.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== id; });
      this.querySelectorAll('[data-metric]').forEach(metric => { metric.hidden = metric.dataset.metric !== id; });
      this.querySelectorAll('[data-case]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.case === id));
      });
    }
  });
})();
